module.exports = __webpack_public_path__ + "static/media/markdown_editor.7e401202.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/markdown_editor.mp4
// module id = 258
// module chunks = 0